import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CreateInstructorViewModel, InstructorViewModel, StringViewModel, UserLookupViewModel } from 'src/app/_models/generatedModels';
import { InstructorService, OrganizationService, UserService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';

@Component({
  selector: 'bxl-add-person-modal',
  templateUrl: 'add-person-modal.component.html',
})
export class AddPersonModalComponent implements OnInit {
  initialized = false;
  userExists = false;
  textEditMode = true;
  existingUser: UserLookupViewModel;
  public formGroup: FormGroup;
  uploadUrl: string;
  instructor: InstructorViewModel;
  avatar: string;
  submitComplete: Promise<{}> | undefined;
  @Input() organizationId: any;
  @Input() conferenceId: any;
  @Input() instructorId: any;
  @Input() personType: string;
  filterChanged: Subject<string> = new Subject<string>();

  constructor(private userData: UserService, private instructorData: InstructorService, private orgData: OrganizationService, private activeModal: NgbActiveModal, private toastr: ToasterService, private fb: FormBuilder) {
    this.filterChanged.pipe(debounceTime(500), distinctUntilChanged()).subscribe((model) => {
      this.checkExistingEmail(model);
    });
  }

  ngOnInit(): void {
    this.uploadUrl = '/api/uploadImage';

    if (this.instructorId != null) {
      this.instructorData.getById(this.instructorId).subscribe((instructor) => {
        this.instructor = instructor;
        this.setupForm();
      });
    } else {
      this.instructor = new InstructorViewModel();
      this.instructor.featured = false;
      this.setupForm();
    }
  }

  checkExistingEmail(val: string) {
    let emailValid = this.formGroup.controls.email.valid;
    if (!emailValid) {
      this.userExists = false;
      return;
    }

    let model = new StringViewModel();
    model.value = val;
    this.orgData.lookupUserByEmail(model).subscribe((result) => {
      this.userExists = result.found;

      if (result.found) {
        this.existingUser = result;
      } else {
        this.existingUser = null;
      }

      console.log(this.userExists);
    });
  }

  linkExistingUser() {
    this.submitComplete = new Promise((resetButton: any, reject) => {
      this.instructorData.getById(this.existingUser.id.toString()).subscribe((instructor) => {
        this.instructor = instructor;
        this.instructorId = instructor.id;
        this.setupForm();
        this.userExists = false;
        resetButton();
      });
    });

    // this.submitComplete = new Promise((resetButton: any, reject) => {
    //   this.orgData.linkSpeakerToOrganization(this.organizationId, this.existingUser.id).subscribe(
    //     (result) => {
    //       this.activeModal.dismiss();
    //       resetButton();
    //     },
    //     () => resetButton()
    //   );
    // });
  }

  onSave() {
    if (!this.formGroup.valid) {
      this.formGroup.markAllControlsDirty();
      this.toastr.error('Please fill out all required fields', 'Error');
      return;
    }

    this.submitComplete = new Promise((resetButton: any, reject) => {
      const formData: CreateInstructorViewModel = Object.assign({}, this.instructor, this.formGroup.value);
      formData.avatar = this.avatar;
      formData.organizationId = this.organizationId;
      formData.genderIdentity = this.formGroup.controls.genderIdentity.value == 'SELF' ? this.formGroup.controls.genderIdentityText.value :  this.formGroup.controls.genderIdentity.value;
      formData.raceEthnicity = this.formGroup.controls.raceEthnicity.value == 'SELF' ? this.formGroup.controls.raceEthnicityText.value :  this.formGroup.controls.raceEthnicity.value;

      if (this.instructor.id != null) {
        this.update(formData, resetButton);
      } else {
        this.save(formData, resetButton);
      }
    });
  }

  successEventHandler(e) {
    // Get the file URI from the response
    this.avatar = e.response.body.name;
  }

  save(formData: CreateInstructorViewModel, resetButton: () => any) {
    this.instructorData.create(formData).subscribe(
      (instructor) => {
        this.activeModal.dismiss(instructor);
        this.toastr.success('User Added', 'Success');
        resetButton();
      },
      (error) => resetButton()
    );
  }

  update(formData: CreateInstructorViewModel, resetButton: () => any) {
    this.instructorData.update(this.instructorId, formData).subscribe(
      (instructor) => {
        this.activeModal.dismiss(instructor);
        this.toastr.success('User Updated', 'Success');
        resetButton();
      },
      (error) => resetButton()
    );
  }

  setupForm(): any {
    this.formGroup = this.fb.group({
      firstName: [this.instructor.firstName, [Validators.required]],
      lastName: [this.instructor.lastName, [Validators.required]],
      email: [this.instructor.email, Validators.compose([Validators.required, Validators.email])],
      credentials: [this.instructor.credentials],
      isBCBA: [this.instructor.isBCBA, [Validators.required]],
      affiliation: [this.instructor.affiliation],
      organizationalTitle: [this.instructor.organizationalTitle],
      phoneNumber: [this.instructor.phoneNumber],
      certificantNumber: [this.instructor.certificantNumber],
      biography: [this.instructor.biography],
      pronouns: [this.instructor.pronouns],
      genderIdentity: [this.instructor.genderIdentity],
      genderIdentityText: [this.instructor.genderIdentity],
      raceEthnicity: [this.instructor.raceEthnicity],
      raceEthnicityText: [this.instructor.raceEthnicity]
    });

    this.avatar = this.instructor.avatar;

    this.formGroup.controls.email.valueChanges.subscribe((val) => {
      console.log(val);
      this.filterChanged.next(val);
    });

    this.initialized = true;
  }

  onCancel() {
    this.activeModal.close();
  }
}
